import React, { useState } from 'react';
import {
  Avatar,
  Accordion,
  Button,
  Stack,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { BadgeStatus } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import {
  PencilIcon,
  NotStartedIcon,
  CircleCheckIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';
import type { Applicant } from '../../../CreateApplication/types';
import { Panel } from 'react-bootstrap';
import { partial } from 'ramda';
import type { DecisionStatus } from '../../types';
import ChecklistItem from '../ChecklistItem';
import messages from './messages';
import ApplicantApprovalContainer from './ApplicantApprovalContainer';
import DownloadAffordaPortalApplicationPDF from '../button.downloadAffordaPortalApplicationPDF';

type Props = {
  intl: Object,
  applicant: Applicant,
  applicationDecisionStatus: Array<DecisionStatus>,
  handleChecklistOptionChange?: Function,
  handleEditApplicationForm: Function,
  approveApplicant?: Function,
  cancelApplicant?: Function,
  isResident?: boolean,
  deniedReasons?: ?any,
  isCanceled?: boolean,
  leaseExecuted?: boolean,
  leaseSentToPortal?: boolean,
};

const ApplicantChecklistToggle = (props: Props) => {
  const {
    isResident,
    deniedReasons,
    isCanceled,
    leaseExecuted,
    leaseSentToPortal,
    affordaPortaV1,
  } = props;

  const [open, setOpen] = useState(false);

  const applicant = props.applicant;
  const applicationDecisionStatus = props.applicationDecisionStatus;
  const handleSubmit = (state, cancelCallback) => {
    if (!state.decision) {
      return;
    }
    if (state.decision === 'approve') {
      // $FlowFixMe
      props.approveApplicant(applicant, cancelCallback);
    } else {
      // $FlowFixMe
      props.cancelApplicant(applicant, state.cancelReasonId);
    }
  };
  const applicantType = applicant?.applicantType?.name ?? null;
  const checklistItems = applicant?.checklist?.checklistItems || [];
  const checklistApproved = applicant?.checklist?.approved || null;
  const isAdult = applicant?.applicantCustomer;
  const portalUserId = applicant?.applicantCustomer?.customer?.pu?.id ?? null;
  const isPriorResident = isAdult?.customer?.status === 'Prior Resident';
  const hasPortalAccount = Boolean(portalUserId);

  return (
    <Accordion
      expandIcon={isResident ? undefined : null}
      expanded={open}
      onChange={() => !isResident && setOpen(!open)}
      summary={
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          spacing={2}
          sx={{
            width: '100%',
          }}
        >
          <Stack direction={'row'} alignItems={'center'} spacing={2}>
            <Avatar
              sx={{
                height: 32,
                width: 32,
                backgroundColor: checklistApproved
                  ? 'success.main'
                  : 'error.main',
              }}
            >
              {checklistApproved ? <CircleCheckIcon /> : <NotStartedIcon />}
            </Avatar>
            <Typography
              variant={'titleSmall'}
              color={isPriorResident ? 'text.secondary' : 'text.primary'}
              className={isPriorResident ? 'text.secondary' : 'text.primary'}
            >
              {applicant.name}
            </Typography>
          </Stack>

          <Stack direction={'row'} alignItems={'center'} spacing={2}>
            <BadgeStatus
              variant={'outlined'}
              sx={{
                color: isPriorResident ? 'text.secondary' : 'text.primary',
              }}
            >
              {applicantType}
            </BadgeStatus>
            {isAdult && (
              <Button
                size={'small'}
                variant={'text'}
                color={'primary'}
                endIcon={<PencilIcon />}
                disabled={isResident || leaseExecuted || leaseSentToPortal}
                onClick={partial(props.handleEditApplicationForm, [applicant])}
              >
                {props.intl.formatMessage(messages.applicationLabel)}
              </Button>
            )}
            {isAdult && hasPortalAccount && affordaPortaV1 && (
              <DownloadAffordaPortalApplicationPDF
                portalUserId={portalUserId}
                name={applicant.name}
              />
            )}
          </Stack>
        </Stack>
      }
    >
      <>
        <Panel.Body>
          <table className="table table-prospects table-ledger table-documents">
            <thead className="table-titles table-header">
              <tr>
                <th>Checklist</th>
                <th>Option</th>
                <th>Status</th>
                <th>Decision</th>
              </tr>
            </thead>
            <tbody>
              {checklistItems.map((item) => (
                <ChecklistItem
                  key={item.id}
                  item={item}
                  applicationDecisionStatuses={applicationDecisionStatus}
                  handleChecklistOptionChange={
                    props.handleChecklistOptionChange
                      ? props.handleChecklistOptionChange(applicant)
                      : null
                  }
                  chooseMessage={props.intl.formatMessage(
                    messages.chooseOption,
                  )}
                />
              ))}
            </tbody>
          </table>
        </Panel.Body>
        {!isCanceled && (
          <ApplicantApprovalContainer
            checklistApproved={checklistApproved}
            handleSubmit={handleSubmit}
            deniedReasons={deniedReasons}
          />
        )}
      </>
    </Accordion>
  );
};

export default ApplicantChecklistToggle;
